<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary">Payment</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent">Sales Payment</a>
              </li>
              <li class="breadcrumb-item active">
              <span v-if="payment.id === null">New</span>
              <span v-else>
                  {{ payment.group_no }}
              </span>
              </li>
            </ol>
            <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="payment.group_no !== null">Action</button>
            <div class="dropdown-menu" aria-labelledby="printsales">
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
              <!-- <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestVoid" data-backdrop="static" data-keyboard="false">Request Delete</a> -->
              <a class="dropdown-item" href="javascript:void(0)" @click="print">Print</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="setJournal('reply')">Set Journal</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="deletePayment" v-if="authUser.permissions.sale_payment_void">Delete</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="unlockPayment" v-if="authUser.permissions.sale_payment_void">Unlock</a>
            </div>
            <button type="button" @click="savePayment" class="btn btn-sm btn-soft-primary pull-left" v-show="payment.id === null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
            <button type="button" @click="updatePayment" class="btn btn-sm btn-soft-primary pull-left" v-show="payment.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
            <button type="button" @click="approvePayment" class="btn btn-sm btn-hard-outline-primary pull-left" v-show="payment.id !== null"><i class="fa fa-check"></i> Approve</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card card-list">
                <div class="card-header">
                    <div class="col-md-12">
                        <h5 class="text-primary">
                        <span v-if="payment.id === null">New</span>
                        <span v-else>{{ payment.group_no }}</span>
                        <span class="badge badge-success ml-1" v-if="payment.status === 'approve'">{{ payment.status }}</span>
                        <span class="badge badge-primary ml-1" v-else>{{ payment.status }}</span>
                        </h5>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <dl class="row dl-custom font-12">
                            <dt class="col-md-4">Company</dt>
                            <dd class="col-md-8">
                                <select v-model="payment.company_no" class="form-control" :disabled="payment.id !== null" @change="setCompany">
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                </select>
                            </dd>

                            <dt class="col-md-4">Category</dt>
                            <dd class="col-md-8">
                              <select v-model="payment.category" class="form-control">
                                <option value="all-sales">All Sales</option>
                                <option value="all-purchasing">All Purchasing</option>
                              </select>
                            </dd>

                            <dt class="col-md-4">Method</dt>
                            <dd class="col-md-8">
                              <select class="form-control form-control-lite" v-model="payment.method_id" @change="setMethod" :disabled="payment.lock">
                                <option v-for="m in methodList" :key="m.id" :value="m.id">{{ m.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-4">Account</dt>
                            <dd class="col-md-8">
                                <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="payment.account_code" :disabled="payment.lock"/>
                            </dd>
                            <dt class="col-md-4">Create Date</dt>
                            <dd class="col-md-8">
                                <span v-if="payment.lock === true">{{ payment.payment_date | dateFormat('DD/MM/YYYY') }}</span>
                                <datetime v-else v-model="payment.payment_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                            </dd>

                            <dt class="col-md-4" v-if="payment.method_id ===3">Finish date</dt>
                            <dd class="col-md-8" v-if="payment.method_id ===3">
                                <span v-if="payment.lock === true">{{ payment.finish_date | dateFormat('DD/MM/YYYY') }}</span>
                                <datetime v-else v-model="payment.finish_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                            </dd>

                            <dt class="col-md-4" v-if="payment.method_id ===3">Giro No.</dt>
                            <dd class="col-md-8" v-if="payment.method_id ===3">
                              <span v-if="payment.lock === true">{{ payment.giro_no }}</span>
                              <input v-else type="text" class="form-control form-control-lite" v-model="payment.giro_no" />
                            </dd>

                            <dt class="col-md-4" v-if="payment.method_id ===3">Bank</dt>
                            <dd class="col-md-8" v-if="payment.method_id ===3">
                              <select v-model="payment.bank_id" class="form-control" :disabled="payment.lock">
                                <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }}</option>
                              </select>
                            </dd>

                            <dt class="col-md-4" v-if="payment.method_id ===3">Bank Name</dt>
                            <dd class="col-md-8" v-if="payment.method_id ===3">
                              <span v-if="payment.lock === true">{{ payment.bank_name }}</span>
                              <input v-else type="text" class="form-control form-control-lite" v-model="payment.bank_name" />
                            </dd>
                        </dl>
                      </div>
                      <!-- <div class="col-md-6">
                        <dl class="row dl-custom">
                            <dt class="col-md-4">Method</dt>
                            <dd class="col-md-8">
                              <select class="form-control form-control-lite" v-model="payment.method_id" @change="setMethod" :disabled="payment.lock">
                                <option v-for="m in methodList" :key="m.id" :value="m.id">{{ m.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-4">Account</dt>
                            <dd class="col-md-8">
                                <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="payment.account_code" :disabled="payment.lock"/>
                            </dd>
                            <dt class="col-md-4">Amount</dt>
                            <dd class="col-md-8">
                                <span v-if="payment.lock == true">{{ payment.total | currency }}</span>
                                <input v-else class="form-control form-control-lite" type="text" v-model="payment.total" v-money="money" :disabled="payment.lock"/>
                            </dd>
                        </dl>
                      </div> -->
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-md-12">
                        <ul class="nav nav-tabs nav-bordered">
                          <li class="nav-item"><a href="#payment" data-toggle="tab" aria-expanded="false" class="nav-link active">Payment</a></li>
                          <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
                          <li class="nav-item"><a href="#sales-data" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a></li>
                        </ul>
                        <div class="tab-content">
                          <div class="tab-pane active" id="payment">
                            <div class="row justify-content-center">
                                <div class="col-md-8">
                                    <div class="text-center">
                                        <h5><b>.: Sales :.</b></h5>
                                    </div>
                                    <dl class="row dl-custom">
                                        <dt class="col-md-10">
                                            <v-select class="vsc-custom" :options="customerSelect" :reduce="customer => customer.meta.code" label="customer" v-model="payment.customer_no" :disabled="payment.lock"/>
                                        </dt>
                                        <dd class="col-md-2">
                                            <button type="button" class="btn btn-sm btn-hard-primary" @click="searchCustomer" :disabled="payment.lock" data-toggle="modal" data-target="#modalSalePaymentGroup" data-backdrop="static" data-keyboard="false" ><i class="fa fa-search"></i></button>
                                        </dd>
                                    </dl>
                                    <hr>
                                    <div class="table-responsive">
                                        <table class="table table-item table-sm table-hover table-striped">
                                            <thead>
                                                <th>Tgl.</th>
                                                <th>Payment No</th>
                                                <th>Notes</th>
                                                <th>Amount</th>
                                                <th class="text-right">#</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(p, index) in payment.sales" :key="p.id">
                                                    <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                                    <td>{{ p.payment_no }}</td>
                                                    <td><input type="text" v-model="p.notes" class="form-control" :disabled="payment.lock" /></td>
                                                    <td><input type="text" v-model="p.price" class="form-control form-control-right" v-money="money" :disabled="payment.lock"/></td>
                                                    <td class="text-right">
                                                        <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removePaymentSales(index)" :disabled="payment.lock"><i class="fa fa-trash"></i></button>
                                                    </td>

                                                </tr>
                                                <!-- <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Amount Due</td>
                                                <td class="text-right">{{ totalSalePaymentOutstanding | currency }}</td>
                                                <td></td>
                                                </tr> -->
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td class="text-right"><b>Subtotal:</b></td>
                                                    <td class="text-right"><b>{{ totalProcessPayment | currency }}</b></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row justify-content-center">
                                <div class="col-md-8">
                                    <div class="text-center">
                                        <h5><b>.: Purchasing :.</b></h5>
                                    </div>
                                    <dl class="row dl-custom">
                                        <dt class="col-md-10"><v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="payment.vendor_no" :disabled="payment.lock"/></dt>
                                        <dd class="col-md-2">
                                            <button type="button" class="btn btn-sm btn-hard-primary" @click="searchVendor" :disabled="payment.lock" data-toggle="modal" data-target="#modalPurchasingPaymentGroup" data-backdrop="static" data-keyboard="false" ><i class="fa fa-search"></i></button>
                                        </dd>
                                    </dl>
                                    <hr>
                                    <div class="table-responsive">
                                        <table class="table table-item table-sm table-hover table-striped">
                                            <thead>
                                                <th>Tgl.</th>
                                                <th>Payment No</th>
                                                <th>Notes</th>
                                                <th>Amount</th>
                                                <th class="text-right">#</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(p, index) in payment.purchasings" :key="p.id">
                                                    <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                                    <td>{{ p.payment_no }}</td>
                                                    <td><input type="text" v-model="p.notes" class="form-control" :disabled="payment.lock" /></td>
                                                    <td><input type="text" v-model="p.price" class="form-control form-control-right" v-money="money2" :disabled="payment.lock"/></td>
                                                    <td class="text-right">
                                                        <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removePaymentPurchasing(index)" :disabled="payment.lock"><i class="fa fa-trash"></i></button>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td class="text-right"><b>Subtotal:</b></td>
                                                    <td class="text-right"><b>{{ totalProcessPaymentVendor | currency }}</b></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            <div class="row justify-content-center">
                                <div class="col-md-8">
                                    <div class="text-center">
                                        <h5><b>.: Summary :.</b></h5>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table table-sm table-item table-hover table-striped">
                                            <thead>
                                                <th style="width:60%">Category</th>
                                                <th style="width: 40%" class="text-right">Amount</th>
                                            </thead>
                                            <tbody v-if="payment.category === 'all-sales'">
                                                <tr>
                                                    <td>Sales</td>
                                                    <td class="text-right">{{ totalProcessPayment | currency }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Purchasing</td>
                                                    <td class="text-right">{{ totalProcessPaymentVendor | currency }}</td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else-if="payment.category === 'all-purchasing'">
                                              <tr>
                                                <td>Purchasing</td>
                                                <td class="text-right">{{ totalProcessPaymentVendor | currency }}</td>
                                              </tr>
                                              <tr>
                                                <td>Sales</td>
                                                <td class="text-right">{{ totalProcessPayment | currency }}</td>
                                              </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td class="text-right"><b>Subtotal</b></td>
                                                    <td class="text-right">
                                                        {{ totalOustandingPayment | currency }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-right"><b>Discount</b></td>
                                                    <td class="text-right">
                                                        <input type="text" v-model="payment.discount" v-money="money" class="form-control form-control-right" @input="calcTotal"/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-right"><b>Round</b></td>
                                                    <td class="text-right">
                                                        {{ totalRounding | currency }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-right"><b>Amount</b></td>
                                                    <td class="text-right">
                                                        <!-- <b>{{ totalOustandingPayment | currency }}</b> -->
                                                        <input class="form-control form-control-right" type="text" v-model="payment.total" v-money="money" :disabled="payment.lock"/>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                          </div>
                          <div class="tab-pane" id="journal">
                            <div class="table-responsive">
                              <table class="table table-sm table-item table-hover table-striped">
                                <thead>
                                  <th>Journal Code</th>
                                  <th>Date</th>
                                  <th>Account Code</th>
                                  <th>Remark</th>
                                  <th class="text-right">Debit</th>
                                  <th class="text-right">Credit</th>
                                </thead>
                                <tbody>
                                  <tr v-for="j in payment.journals" :key="j.id">
                                    <td>
                                      <span v-if="j.level === 1">
                                        <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                        <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                        <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                      </span>
                                      <span v-else></span>
                                    </td>
                                    <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                    <td>{{ j.remark }}</td>
                                    <td class="text-right">
                                      <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                      <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                      <span v-else></span>
                                    </td>
                                    <td class="text-right">
                                      <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                      <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                      <span v-else></span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button>
                            </div>
                          </div>
                          <div class="tab-pane" id="sales-data">
                            <div class="table-responsive">
                              <table class="table table-sm table-item table-striped">
                                <thead>
                                  <th>Sale No</th>
                                  <th>Payment No.</th>
                                  <th>Date</th>
                                  <th>Due Date</th>
                                  <th>Customer</th>
                                  <th>Salesman</th>
                                  <th>Method</th>
                                  <th class="text-right">Subtotal</th>
                                  <th class="text-right">Discount</th>
                                  <th class="text-right">Tax</th>
                                  <th class="text-right">Total</th>
                                  <th class="text-right">Outstanding</th>
                                </thead>
                                <tbody>
                                  <tr v-for="d in payment.saleData" :key="d.id">
                                    <td v-if="d.level ===1"><b>{{ d.sale_no }}</b></td>
                                    <td v-else>
                                      <span class="ml-5">
                                        <i>{{ d.payment_no }}</i>
                                      </span>
                                    </td>

                                    <td>{{ d.group_no }}</td>

                                    <td v-if="d.level === 1">{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td v-else>{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</td>

                                    <td v-if="d.level === 1">{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td v-else></td>

                                    <td v-if="d.level === 1">{{ d.customer }}</td>
                                    <td v-else></td>

                                    <td v-if="d.level === 1">{{ d.salesman }}</td>
                                    <td v-else></td>

                                    <td v-if="d.level === 1"></td>
                                    <td v-else>{{ d.method }}</td>

                                    <td v-if="d.level === 1" class="text-right">{{ d.subtotal | currency }}</td>
                                    <td v-else class="text-right"></td>

                                    <td v-if="d.level === 1" class="text-right">{{ d.discount | currency }}</td>
                                    <td v-else class="text-right"></td>

                                    <td v-if="d.level === 1" class="text-right">{{ d.tax | currency }}</td>
                                    <td v-else class="text-right"></td>

                                    <td class="text-right">{{ d.total | currency }}</td>

                                    <td v-if="d.level === 1" class="text-right">{{ d.outstanding | currency }}</td>
                                    <td v-else class="text-right"></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid"/>
    <SalePaymentGroupModal @processPayment="processPayment" @processPaymentVendor="processPaymentVendor"/>
    <!-- <pre>{{ payment.category }}</pre> -->
  </div>
</template>
<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import SalePaymentGroupModal from '@/components/payment/SalePaymentGroupModal.vue'
import { getHeader, paymentUrl, lockUrl, journalUrl, salesUrl, sale2Url, purchasingUrl } from '../../config'

export default {
  name: 'PaymentGroupForm',
  props: ['payment'],
  components: {
    SalesRequestModal,
    SalePaymentGroupModal
  },
  data () {
    return {
      selectAll: false,
      selected: [],
      paymentData: {},
      dataRaw: [{
        id: 1,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        vendor: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        taxes: null,
        discount: 0,
        total: '0',
        payment_total: '0',
        outstanding: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        type_id: null,
        lock: false,
        company_no: null,
        term_due_id: null,
        ext_no: null,
        sp_no: null,
        discount_percentage: null,
        schedule_payment_date: null
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      customerList: state => state.customers.customerListLite,
      typeList: state => state.payments.typeList,
      methodList: state => state.payments.methodList,
      chartOfAccountList: state => state.accounts.chartOfAccountList,
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      vendorList: state => state.vendors.vendorList
    }),
    totalOustandingPayment () {
      var payment = 0
      if (this.payment.category === 'all-sales') {
        payment = this.totalProcessPayment - this.totalProcessPaymentVendor
      } else {
        payment = this.totalProcessPaymentVendor - this.totalProcessPayment
      }
      return payment
    },
    totalPayment () {
      var discount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var total = 0
      total = this.totalProcessPayment - discount
      return total
    },
    totalRounding () {
      var totalPayment = parseFloat(this.payment.total.replace(/\./g, ''))
      const totalDiscount = parseFloat(this.payment.discount.replace(/\./g, ''))
      const subtotal = this.totalOustandingPayment - totalDiscount
      var round = 0
      if (totalPayment !== 0) {
        round = totalPayment - subtotal
      }
      return round
    },
    totalSalePaymentOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    totalProcessPayment () {
      var sum = 0
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.toString().replace(/\./g, ''))
      }
      return sum
    },
    totalProcessPaymentVendor () {
      var sum = 0
      var array = this.payment.purchasings
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.toString().replace(/\./g, ''))
      }
      return sum
    },
    customerSelect () {
      var loop = []
      var array = this.customerList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          customer: array[i].customer_no + ' - ' + array[i].name,
          meta: {
            code: array[i].customer_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    accountSelectCheck () {
      var account = this.chartOfAccountList.filter(d => d.company_no === this.payment.company_no)
      return account
    },
    accountSelect () {
      var loop = []
      var array = []
      var methodID = this.payment.method_id === null || this.payment.method_id === '' ? 1 : this.payment.method_id
      if (methodID === 1) {
        array = this.accountSelectCheck
      } else {
        array = this.accountSelectCheck
      }
      console.log(array)
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: array[i].code + ' - ' + array[i].name,
          meta: {
            code: array[i].code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async requestVoid (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.sales.sale_no,
        lock_note: value,
        type: 'payment-void'
      }
      console.log(obj)
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Payment has been requested', 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async voidPayment () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        id: this.payment.id
      }
      await Axios.post(paymentUrl + '/void', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async deletePayment () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          Axios.delete(paymentUrl + '/' + this.payment.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.$emit('backSaveClicked')
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async unlockPayment () {
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, unlock it!'
      }).then((result) => {
        if (result.value) {
          Axios.post(paymentUrl + '/unlock', { id: this.payment.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.payment.lock = false
              this.$emit('backSaveClicked')
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    calcPaymentTotal () {
      var payment = this.totalProcessPayment - this.totalProcessPaymentVendor
      this.payment.total = payment.toString()
    },
    setCompany () {
      this.payment.account_code = null
      this.payment.method_id = null
    },
    calcTotal () {
      var discount = this.payment.discount.replace(/\./g, '')
      var total = parseFloat(this.totalProcessPayment) - parseFloat(discount)
      console.log(total)
    },
    processPayment (value) {
      console.log(value)
      var array = value
      for (let i = 0; i < array.length; i++) {
        var obj = {
          payment_no: null,
          sale_no: array[i].sale_no,
          payment_date: this.payment_date,
          price: array[i].outstanding,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: this.payment.notes,
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.sales.push(obj)
      }
      this.calcPaymentTotal()
    },
    processPaymentVendor (value) {
      var array = value
      console.log('processPaymentVendor')
      for (let i = 0; i < array.length; i++) {
        var obj = {
          payment_no: null,
          purchasing_no: array[i].purchasing_no,
          payment_date: this.payment_date,
          price: array[i].outstanding,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: this.payment.notes,
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.purchasings.push(obj)
      }
      this.calcPaymentTotal()
    },
    async postJournal () {
      var array = this.payment.journals.filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        var data = {
          id: array[i].id
        }
        await Axios.post(journalUrl + '/posting', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            return false
          })
      }
      await this.$swal('Success', 'Success Post All Journal', 'success')
      await this.$emit('backClickID', this.payment.id)
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.payment.group_no,
        lock_note: value,
        type: 'payment-sales'
      }
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Payment has been requested', 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async removePaymentSales (index) {
      var sales = this.payment.sales[index]
      if (typeof sales.id === 'undefined') {
        this.payment.sales.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(salesUrl + '/payment/' + sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                this.payment.sales.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
      await this.calcPaymentTotal()
    },
    async removePaymentPurchasing (index) {
      var po = this.payment.purchasings[index]
      if (typeof po.id === 'undefined') {
        this.payment.purchasings.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(purchasingUrl + '/payment/' + po.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                this.payment.purchasings.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
      await this.calcPaymentTotal()
    },
    async setJournal (status) {
      var data = {
        id: this.payment.id
      }
      await Axios.post(paymentUrl + '/journal-all', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          if (status === 'reply') {
            this.$swal('Success', response.data.message, 'success')
            this.$emit('backSaveClicked')
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async approvePayment () {
      var data = {
        group_no: this.payment.group_no
      }
      await this.updatePayment()
      var message = {
        error: false,
        message: null
      }
      await Axios.post(paymentUrl + '/approve', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          message.error = false
          message.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          message.error = true
          message.message = error.response.data.message
          return false
        })
      await this.setJournal('noreply')
      if (message.error === false) {
        this.$swal('Success', message.message, 'success')
      } else {
        this.$swal('Error', message.message, 'error')
      }
      await this.$emit('backSaveClicked')
    },
    async updatePayment () {
      // var price = parseFloat(this.payment.total.replace(/\./g, ''))
      // var total = parseFloat(this.totalProcessPayment)
      // if (price !== total) {
      //   this.$swal(
      //     'Error',
      //     'Total process tidak sama (' + price + ' >< ' + total + ')',
      //     'error'
      //   )
      //   return false
      // }
      var pdata = []
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          obj = {
            id: array[i].id,
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        }
        pdata.push(obj)
      }
      var purchase = []
      var arr = this.payment.purchasings
      for (let i = 0; i < arr.length; i++) {
        var ob = {}
        var price = arr[i].price.replace(/\./g, '')
        price = price.replace(',', '.')
        if (typeof arr[i].id === 'undefined') {
          console.log(arr[i])
          ob = {
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          ob = {
            id: arr[i].id,
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        }
        purchase.push(ob)
      }
      var paymentDiscount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var paymentDiscountPercentage = 0
      if (paymentDiscount !== 0) {
        paymentDiscountPercentage = (paymentDiscountPercentage / this.totalProcessPayment) * 100
      }
      var createDate = this.payment.payment_date
      var finishDate = this.payment.finish_date
      if (this.payment.method_id !== 3) {
        finishDate = this.payment.payment_date
      }
      var category = null
      if (this.totalProcessPayment > this.totalProcessPaymentVendor) {
        category = 'all-sales'
      } else {
        category = 'all-purchasing'
      }
      this.paymentData = {
        id: this.payment.id,
        group_no: this.payment.group_no,
        prepayment_date: this.payment.prepayment_date,
        finish_date: finishDate,
        payment_date: createDate,
        category: category,
        total: this.payment.total.replace(/\./g, ''),
        method_id: this.payment.method_id,
        type_id: this.payment.type_id,
        bank_id: this.payment.bank_id,
        account_code: this.payment.account_code,
        notes: this.payment.notes,
        vendor_no: this.payment.vendor_no,
        customer_no: this.payment.customer_no,
        branch_no: this.authUser.branch_no,
        company_no: this.authUser.company_no,
        status: this.payment.status,
        subtotal: this.totalOustandingPayment,
        discount: paymentDiscount,
        discount_percentage: paymentDiscountPercentage,
        round: this.totalRounding,
        lock: this.payment.lock,
        finish: this.payment.finish,
        manual_journal: this.payment.manual_journal,
        giro_no: this.payment.giro_no,
        bank_name: this.payment.bank_name,
        sales: pdata,
        purchasings: purchase
      }
      await Axios.put(paymentUrl + '/' + this.payment.id, this.paymentData, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async savePayment () {
      var pdata = []
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          obj = {
            id: array[i].id,
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        }
        pdata.push(obj)
      }
      var purchase = []
      var arr = this.payment.purchasings
      for (let i = 0; i < arr.length; i++) {
        var ob = {}
        var price = arr[i].price.replace(/\./g, '')
        price = price.replace(',', '.')
        if (typeof arr[i].id === 'undefined') {
          console.log(arr[i])
          ob = {
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          ob = {
            id: arr[i].id,
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        }
        purchase.push(ob)
      }
      var paymentDiscount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var paymentDiscountPercentage = 0
      if (paymentDiscount !== 0) {
        paymentDiscountPercentage = (paymentDiscountPercentage / this.totalProcessPayment) * 100
      }
      var createDate = this.payment.payment_date
      var finishDate = this.payment.finish_date
      if (this.payment.method_id !== 3) {
        finishDate = this.payment.payment_date
      }
      var category = null
      if (this.totalProcessPayment > this.totalProcessPaymentVendor) {
        category = 'all-sales'
      } else {
        category = 'all-purchasing'
      }

      this.paymentData = {
        id: null,
        group_no: null,
        prepayment_date: this.payment.prepayment_date,
        finish_date: finishDate,
        payment_date: createDate,
        category: category,
        subtotal: this.totalOustandingPayment,
        round: this.totalRounding,
        discount: paymentDiscount,
        discount_percentage: paymentDiscountPercentage,
        total: this.payment.total.replace(/\./g, ''),
        method_id: this.payment.method_id,
        type_id: this.payment.type_id,
        bank_id: this.payment.bank_id,
        account_code: this.payment.account_code,
        notes: this.payment.notes,
        vendor_no: this.payment.vendor_no,
        customer_no: this.payment.customer_no,
        branch_no: this.payment.branch_no,
        company_no: this.payment.company_no,
        status: this.payment.status,
        lock: this.payment.lock,
        finish: false,
        manual_journal: this.payment.manual_journal,
        giro_no: this.payment.giro_no,
        bank_name: this.payment.bank_name,
        sales: pdata,
        purchasings: purchase
      }
      await Axios.post(paymentUrl, this.paymentData, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async selectAllSales () {
      if (this.selectAll === false) {
        var array = this.dataRaw
        for (let i = 0; i < array.length; i++) {
          this.selected.push(array[i].id)
          this.setData(i)
        }
      } else {
        this.selected = []
        this.payment.sales = []
      }
    },
    async setData (index) {
      var data = this.dataRaw[index]
      var sales = this.payment.sales.find(d => d.sale_no === data.sale_no)
      var price = 0
      //  var salesIndex = this.payment.sales.findIndex(d => d.sale_no === data.sale_no)
      var obj = {}
      if (sales) {
        // price = sales.price.replace(/\./g, '')
        // if (price === 0) {
        //   this.payment.sales.splice(salesIndex, 1)
        // } else {
        //   sales.price = parseFloat(price) + parseFloat(data.outstanding)
        // }
      } else {
        var objPrice = price === 0 ? parseFloat(data.outstanding) : parseFloat(price) - parseFloat(data.outstanding)
        obj = {
          payment_no: null,
          sale_no: data.sale_no,
          payment_date: this.payment.payment_date,
          price: objPrice,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: this.payment.notes,
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.sales.push(obj)
      }
      // this.payment.total = this.totalProcessPayment
    },
    async searchCustomer () {
      this.dataRaw = []
      var data = {
        customer_no: this.payment.customer_no,
        year: this.payment.payment_date,
        company_no: this.payment.company_no
      }
      this.$store.dispatch('getCustomerOutstading', data)
    },
    async searchVendor () {
      this.dataRaw = []
      var payload = {
        vendor_no: this.payment.vendor_no,
        year: this.payment.payment_date,
        company_no: this.payment.company_no
      }
      this.$store.dispatch('getVendorOutstanding', payload)
    },
    backParent () {
      this.$emit('backClicked')
    },
    setMethod () {
      var methodID = this.payment.method_id
      if (methodID === 1) {
        if (this.payment.company_no === 'C0001') {
          this.payment.account_code = '01-111-002'
        } else {
          this.payment.account_code = '11-111-002'
        }
        this.payment.prepayment_date = null
      } else if (methodID === 3) {
        if (this.payment.id == null) {
          this.payment.prepayment_date = null
          this.payment.payment_date = null
        }
      } else {
        this.payment.account_code = null
        this.payment.prepayment_date = null
      }
    },
    async print () {
      window.open(sale2Url + '/print/' + this.payment.id + '/kwitansi', '_blank')
    }
  }
}
</script>
